<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import SidebarMain from "@/components/SidebarMain.vue";

const route = useRoute();

// Entity pages (meta.pageKeyParam) rebuild only when the entity changes, so tab clicks keep the page shell.
const pageKey = computed(() => {
  const keyParam = route.meta.pageKeyParam;
  if (typeof keyParam !== "string") return route.fullPath;
  return String(route.params[keyParam]);
});
</script>

<template>
  <div class="pv-app-shell flex h-screen overflow-hidden">
    <SidebarMain />
    <main class="pv-content flex-1 overflow-y-auto" :style="{ marginLeft: '80px' }">
      <!-- Main Content -->
      <div class="p-6">
        <router-view :key="pageKey"/>
      </div>
    </main>
  </div>
</template>